
/**
 * @constructor
 * 该类包含了页面中所有事件的存储、执行、全部组件上下文的存储
 */
class SubPageEvent {
  constructor() {
    this.contexts = {} //存储全局所有的组件的this
  }
  /**
   * 将组件中的this保存到事件总线中
   * @param {object} id 组件的id
   * @param {object} innerElement 组件的类型
   * @param {object} context 组件中的this
   */
  addContext(id, innerElement, context) {
    if (!this.contexts[id]) {
      this.contexts[innerElement + "_" + id] = context
    }
  }

  /**
   * 删除组件中的this
   * @param {object} id 组件的id
   * @param {object} innerElement 组件的类型
   */
  removeContext(id, innerElement) {
    delete this.contexts[innerElement + "_" +id]
  }
}


export const subPageEvent = new SubPageEvent()
